import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveDataList } from './ResponsiveDataList.js';
import { PaginationHeader } from '../PaginationHeader.js';
import { getPagingInfo, Pagination } from '../Pagination.js';
import { getPageSize } from '../../utils/pageSize.js';
import { getTotalCount } from '../../utils/totalCount.js';

var PagingDataList = /*#__PURE__*/function (_React$Component) {
  function PagingDataList(props) {
    var _this;

    _classCallCheck(this, PagingDataList);

    _this = _callSuper(this, PagingDataList, [props]);

    _defineProperty(_this, "onPageChange", function (eventKey) {
      _this.setState({
        activePage: eventKey
      });

      _this.props.onPageChange(eventKey);
    });

    _defineProperty(_this, "highlightRow", function (value) {
      if (_this.responsiveDataList) {
        _this.responsiveDataList.highlightRow(value);
      }
    });

    _defineProperty(_this, "changePageSize", function (page_size) {
      getPageSize(page_size);

      _this.props.onPageChange(1);
    });

    _this.state = {
      activePage: props.activePage || 1
    };
    return _this;
  }

  _inherits(PagingDataList, _React$Component);

  return _createClass(PagingDataList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.pageSize && this.props.pageSize !== getPageSize()) {
        this.changePageSize(this.props.pageSize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!!this.props.activePage && this.props.activePage !== prevProps.activePage) {
        this.setState({
          activePage: this.props.activePage
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var pagingInfo = getPagingInfo(this.props);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaginationHeader, _extends({}, this.props, {
        activePage: this.state.activePage,
        hasPagination: pagingInfo.hasPagination,
        showPageSizeDropdown: !this.props.pageSize,
        pSize: pagingInfo.pageSize,
        changePageSize: this.changePageSize,
        dataSize: pagingInfo.dataSize
      })), /*#__PURE__*/React.createElement(ResponsiveDataList, _extends({}, this.props, {
        ref: function ref(responsiveDataList) {
          _this2.responsiveDataList = responsiveDataList;
        },
        pagingInfo: pagingInfo,
        onPageChange: this.onPageChange
      })), !this.props.useCoreTable && pagingInfo.hasPagination && /*#__PURE__*/React.createElement(Pagination, {
        data: this.props.data,
        activePage: this.state.activePage,
        isLoadingData: this.props.isLoadingData,
        maxButtons: this.props.maxButtons,
        pageSize: this.props.pageSize,
        totalCount: getTotalCount(this.props.totalCount),
        onPageChange: this.onPageChange
      }));
    }
  }]);
}(React.Component);

_defineProperty(PagingDataList, "propTypes", {
  activePage: PropTypes.number,
  data: PropTypes.array.isRequired,
  isLoadingData: PropTypes.bool,
  maxButtons: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
  useCoreTable: PropTypes.bool
});

_defineProperty(PagingDataList, "defaultProps", {
  resultsDisplayed: true,
  useCoreTable: true
});

PagingDataList.displayName = "PagingDataList";
export { PagingDataList };